import { softDeletePunctualityReport } from '@src/main/modules/reports/punctuality/application/use-cases/soft-delete-punctuality-report.usecase';
import { createPunctualityReportHttpRepository } from '@src/main/modules/reports/punctuality/infrastructure/repository/PunctualityReportHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useSoftDeletePunctualityReport = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createPunctualityReportHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (formId: string) => {
      if (!repository) throw new Error('Repository not initialized');
      return await softDeletePunctualityReport(repository, formId);
    },
  });
};
